import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createAudio(
  parentId: string,
  masterBlockId?: MasterBlockId,
): AudioInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Audio, parentId, masterBlockId),
    type: EntityTypeEnum.Audio,
    url: '',
  }
}
